

























































import Vue, { VNode } from 'vue';
import SidePage from 'common/components/ui/SidePage/index.vue';
import Avatar from './fields/Avatar.vue';
import fieldsDisplayLogic, { CustomerDisplayColumn } from './fields/fieldsDisplayLogic';
import CustomerDetail from './detail/index.vue';
import CustomerExport from './detail/CustomerExport.vue';
import CustomerAnalyze from './analyze/index.vue';
import Customer from '../../models/Customer';
import customerClient from '../../apis';
import customerVuex from '../../vuex/common';
import CustomerProp, { PropType } from '../../models/CustomerProp';
import { CustomerQuery } from '../../models/CustomerQuery';

enum SortOrder {
  Asc = 'asc',
  Desc = 'desc',
  Normal = 'normal',
}

interface CustomerColumn {
  column: Customer;
  key: string;
  order: SortOrder;
}

const columns: CustomerDisplayColumn[] = [];
const customerData: Customer[] = [];

export default Vue.extend({
  mixins: [customerVuex],
  components: {
    SidePage,
    CustomerDetail,
    CustomerExport,
    CustomerAnalyze,
  },
  props: {
    fixed: Boolean,
    canScrollY: {
      type: Boolean,
      default: true,
    },
    shouldInit: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      showCustomerDetail: false,
      noOverflowXClass: true,
      loading: true,
      inited: false,
      dragable: false,
      showExportCustomer: false,
      startX: 0,
      customerData,
      columns,
      scrollbarStyles: {},
      scrollbarThumbStyles: {},
    };
  },
  computed: {
    refreshCounter(): number {
      return this.customerState.customerList.refreshCounter;
    },
    customerQuery(): CustomerQuery {
      return this.customerState.customerQuery;
    },
    realDisplayFields(): string[] {
      const fields = this.customerState.props.filter((prop: CustomerProp) => {
        return this.customerState.displayFields.includes(prop.fieldName);
      }).map((prop: CustomerProp) => prop.fieldName);
      return [
        'wxProps.nickname',
        'wxProps.subscribeTime',
      ].concat(fields).concat('chat');
    },
  },
  methods: {
    hideCustomerDetail() {
      this.$store.commit('HIDE_CUSTOMER_DETAIL');
    },
    hideCustomerExport() {
      this.$store.commit('HIDE_CUSTOMER_EXPORT');
    },
    hideCustomerAnalyze() {
      this.$store.commit('HIDE_CUSTOMER_ANALYZE');
    },
    updateTableColumns() {
      this.columns = this.realDisplayFields.map((fn) => {
        const interactCol = {
          fieldName: 'chat',
          propName: '互动',
          propType: PropType.Other,
          propTypeName: undefined,
          builtIn: true,
        } as CustomerProp;
        const field = this.customerState.props.concat(interactCol).find((p) => {
          return p.fieldName === fn;
        });
        if (field) {
          return fieldsDisplayLogic(this, field, this.columnWidth(field.fieldName), this.widthFixed());
        } else {
          throw new Error('error column data');
        }
      });
    },
    updateCustomerData() {
      this.customerData = this.customerState.customerList.data;
    },
    onPageChange(page: number) {
      if (page >= 200) {
        this.$Message.warning('超出跳转最大页码');
      } else {
        this.$store.commit('UPDATE_CUSTOMER_QUERY', {
          key: 'page',
          value: page,
        });
        this.$store.commit('CUSTOMER_TABLE_REFRESH');
      }
    },
    onPageSizeChange(pageSize: number) {
      this.$store.commit('UPDATE_CUSTOMER_QUERY', {
        key: 'pageSize',
        value: pageSize,
      });
      this.$store.commit('UPDATE_CUSTOMER_QUERY', {
        key: 'page',
        value: 1,
      });
      this.$store.commit('CUSTOMER_TABLE_REFRESH');
      Vue.localStorage.set('customerTablePageSize', pageSize);
    },
    onSort(column: CustomerColumn) {
      const key = column.key === 'interactive.interactiveTime' ? 'latelyInteractiveTime' : column.key;
      this.$store.commit('UPDATE_CUSTOMER_QUERY', {
        key: 'sort',
        value: key + ' ' + column.order,
      });
      this.$store.commit('CUSTOMER_TABLE_REFRESH');
    },
    widthFixed(): boolean {
      if (this.$refs.table) {
        const tableWidth = (this.$refs.table as any).$el.clientWidth;
        return ((tableWidth - 260) / (this.realDisplayFields.length - 1)) < 200;
      } else {
        return false;
      }
    },
    columnWidth(fieldName?: string): number {
      if (fieldName && this.$refs.table) {
        const tableWidth = (this.$refs.table as any).$el.clientWidth;
        const columnsCount = this.realDisplayFields.length;
        if (this.widthFixed()) {
          this.noOverflowXClass = false;
          return fieldName === 'wxProps.nickname' ? 260 : 200;
        } else {
          const width = tableWidth / columnsCount;
          this.noOverflowXClass = true;
          if (width < 260) {
            return fieldName === 'wxProps.nickname' ? 260 : (tableWidth - 260) / (columnsCount - 1);
          } else {
            return width;
          }
        }
      } else {
        return 0;
      }
    },
    renderScrollbarX() {
      if (this.$refs.table) {
        const barWidth = (this.$refs.table as any).$el.clientWidth - 200;
        const fullWidth = window.document.querySelector('.ivu-table-tbody').clientWidth - 200;
        this.scrollbarStyles = {
          width: `${barWidth}px`,
          left: window.document.body.clientWidth - barWidth - 200,
        };
        this.scrollbarThumbStyles = {
          left: 0,
          width: `${barWidth * 100 / fullWidth}%`,
        };
      }
    },
    setTableHeight() {
      const appContent = window.document.getElementById('app-content');
      const el: any = window.document.querySelector('.customer-table .ivu-table-body');
      const fixedEl: any = window.document.querySelector('.customer-table .ivu-table-fixed-body');
      const height = window.document.body.offsetHeight - 289;
      if (el) {
        el['style']['height'] = `${height}px`;
        el['style']['overflow'] = 'auto';
        if (fixedEl) {
          fixedEl['style']['height'] = `${height}px`;
          fixedEl['style']['overflow'] = 'auto';
        }
        const handleMousewheel =  (event: any) => {
          event.preventDefault();
          if (this.canScrollY) {
            el.scrollTop += event.deltaY;
            if (fixedEl) {
              fixedEl.scrollTop += event.deltaY;
            }
            if (el.scrollTop < 0) {
              el.scrollTop = 0;
              if (fixedEl) {
                fixedEl.scrollTop = 0;
              }
            }
            if (event.deltaY >= 0 || el.scrollTop !== 0) {
              event.stopPropagation();
            }
          }
          if (event.deltaX !== 0) {
            el.scrollLeft += event.deltaX;
            this.setScrollbarXOffset(el.scrollLeft);
          }      
        };
        el.addEventListener('mousewheel', handleMousewheel);
        if (fixedEl) {
          fixedEl.addEventListener('mousewheel', handleMousewheel);
        }
      }
    },
    setScrollbarXOffset(offset: number) {
      const barWidth = (this.$refs.table as any).$el.clientWidth - 200;
      const fullWidth = window.document.querySelector('.ivu-table-tbody').clientWidth - 200;
      this.scrollbarThumbStyles = {
        width: (this.scrollbarThumbStyles as any).width,
        left: `${offset * (barWidth * (1 - barWidth / fullWidth) ) / (fullWidth - barWidth) }px`,
      };
    },
    scrollBarDragStart(event: any) {
      this.dragable = true;
      this.startX = event.screenX;
    },
    scrollBarDraging(event: any) {
      const barWidth = (this.$refs.table as any).$el.clientWidth - 200;
      const fullWidth = window.document.querySelector('.ivu-table-tbody').clientWidth - 200;
      const remainWidth = barWidth * (1 - barWidth / fullWidth);
      const el: any = window.document.querySelector('.customer-table .ivu-table-body');
      let offset = event.screenX - this.startX;
      offset = offset > 0 ? offset : 0;
      offset = offset > remainWidth ? remainWidth : offset;
      this.scrollbarThumbStyles = {
        width: (this.scrollbarThumbStyles as any).width,
        left: `${offset}px`,
      };
      el.scrollLeft = (fullWidth - barWidth) * offset / remainWidth;
    },
    scrollBarDragOver() {
      this.dragable = false;
    },
    loadGroups() {
      customerClient.getGroups().success(r => {
        this.$store.commit('UPDATE_CUSTOMER_GROUPS', r.groups);
      });
    },
  },
  watch: {
    refreshCounter() {
      if (!this.customerState.showCustomerDetail) {
        this.loading = true;
      }
      this.$emit('startLoad');
      customerClient.getList(this.customerQuery).success((r) => {
        (r.customers || []).map( (c: any) => {
          c.wxProps.nickname = c.wxProps.nickname || '匿名用户'
        })
        this.$store.commit('UPDATE_CUSTOMER_LIST', r);
        this.updateTableColumns();
        this.updateCustomerData();
        this.$nextTick(() => {
          this.setTableHeight();
          this.renderScrollbarX();
        });
        this.inited = true;
        this.$emit('loaded');
      }).failure((code: string, msg?: string) => {
        this.$Message.error(msg);
      }).error((e) => {
        this.$Message.error(e.toString());
      }).done(() => {
        this.loading = false;
        this.$emit('loaded');
      });
    },
  },
  beforeMount() {
    this.$store.commit('UPDATE_CUSTOMER_QUERY', {
      key: 'pageSize',
      value: parseInt(Vue.localStorage.get('customerTablePageSize', 50)),
    });
  },
  mounted() {
    if (this.shouldInit) {
      this.$store.commit('CUSTOMER_TABLE_RELOAD');
    }
    if (this.customerState.customerGroups.length < 1) {
      this.loadGroups();
    }
    window.addEventListener('resize', () => {
      this.updateTableColumns();
      this.setTableHeight();
    });
    window.addEventListener('mousemove', (event) => {
      if (this.dragable) {
        this.scrollBarDraging(event);
      }  });
    window.addEventListener('mouseup', () => {
      this.dragable = false;
    });
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateTableColumns);
  },
});
